import { render, staticRenderFns } from "./a_bigorder.vue?vue&type=template&id=3189636c&scoped=true"
import script from "./a_bigorder.vue?vue&type=script&lang=js"
export * from "./a_bigorder.vue?vue&type=script&lang=js"
import style0 from "./a_bigorder.vue?vue&type=style&index=0&id=3189636c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189636c",
  null
  
)

export default component.exports